import { render } from "./FormTable.vue?vue&type=template&id=cb8d1370"
import script from "./FormTable.vue?vue&type=script&lang=ts"
export * from "./FormTable.vue?vue&type=script&lang=ts"
script.render = render

export default script